import React from "react";

import { Box, Container, Grid, Typography } from "@mui/material";
import star from "../../assets/star.png";
import disbgimg from "../../assets/disbgimg.png";
import discard from "../../assets/discard.png";

import TabPanel from "./TabPanel";

const Discount = () => {
  return (
    <Box
      sx={{
        background: `url(${star}), #021B33`,
        backgroundSize: "100% 100%",
        height: "100%",
        backgroundRepeat: "no-repeat",
        paddingBottom: "2rem",
      }}
    >
      <Container>
        <Box
          sx={{
            background: `url(${disbgimg})`,
            backgroundSize: "100% 100%",
            height: "100%",
            backgroundRepeat: "no-repeat",
            padding: "2rem",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "25px", md: "36px" },
              fontFamily: "Zen Dots",
              fontWeight: "400",
              textAlign: "center",

              color: "rgba(255, 255, 255, 1)",
            }}
          >
            Document
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#D9D9D9",
              textAlign: "center",
            }}
          >
            Download the whitepaper and learn about ICO Token, the unique ICO
            Crypto approach and the team/advisors.
          </Typography>
          <Box mt={6}>
            <Grid container spacing={2}>
              {[
                "ONE PAPER",
                "WHITE PAPER",
                "PRIVACY POLICY",
                "TERMS OF COINS SALES",
              ].map((item, i) => {
                return (
                  <Grid item lg={3} md={4} sm={6} xs={12} key={i}>
                    <Box
                      textAlign="center"
                      display="flex"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          background: `url(${discard})`,
                          backgroundSize: "100% 100%",
                          backgroundRepeat: "no-repeat",
                          height: { sm: "150px", xs: "200px" },
                          width: { sm: "100%", xs: "250px" },
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "400",
                            fontFamily: "Zen Dots",
                            color: "#D9D9D9",
                            textAlign: "center",
                          }}
                        >
                          {item}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>

        <Box py={5}>
          <Typography
            sx={{
              fontSize: { xs: "25px", md: "36px" },
              fontFamily: "Zen Dots",
              fontWeight: "400",

              color: "rgba(255, 255, 255, 1)",
            }}
          >
            Have any Question?
          </Typography>
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#D9D9D9",
            }}
          >
            Download the whitepaper and learn about ICO Token, the unique ICO
            Crypto approach and the team/advisors.
          </Typography>

          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#D9D9D9",
            }}
          >
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "400",
                fontFamily: "Inter",
                color: "#D9D9D9",
              }}
            >
              Crypto approach and the team/advisors.
            </Typography>
          </Typography>

          <TabPanel />
        </Box>
      </Container>
    </Box>
  );
};

export default Discount;
